module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    },
    on: {
      "save": _vm.fetchOrderStatuses
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Token",
      "error": _vm.getError('auth.token')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.token),
      expression: "config.auth.token"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Digite seu token"
    },
    domProps: {
      "value": (_vm.config.auth.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "token", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Esse token pode ser encontrado no painel administrativo do Tiny.")])])], 1), _vm._v(" "), _c('div', [_c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar produtos automaticamente"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.synchronize),
      expression: "config.product.synchronize"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.synchronize) ? _vm._i(_vm.config.product.synchronize, null) > -1 : (_vm.config.product.synchronize)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.synchronize,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "synchronize", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "synchronize", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "synchronize", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os produtos da fonte de dados devem ser sincronizados automaticamente.")])])], 1)])], 1), _vm._v(" "), _c('div', [_c('panel', {
    attrs: {
      "title": "Status de pedidos"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fetchOrderStatuses()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.fetched) ? _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Pendente"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.pending),
      expression: "config.order.forward.status.pending"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "pending", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Aprovado"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.approved),
      expression: "config.order.forward.status.approved"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "approved", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Cancelado"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.canceled),
      expression: "config.order.forward.status.canceled"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "canceled", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Transporte"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.shipped),
      expression: "config.order.forward.status.shipped"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "shipped", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Somente para pedidos com serviço de entrega.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Entregue"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.status.delivered),
      expression: "config.order.forward.status.delivered"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward.status, "delivered", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
    return _c('option', {
      key: status.code,
      domProps: {
        "value": status.code
      }
    }, [_vm._v(_vm._s(status.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Somente para pedidos com serviço de entrega.")])])], 1)]) : (!_vm.fetching) ? _c('div', {
    staticClass: "u-bolder t-error u-textCenter"
  }, [_vm._v("Não foi possível buscar os status dos pedidos do Tiny.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Frete"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Transportadora padrão"
    }
  }, [(_vm.tinyShippingMethods.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.forward.shippingMethodDefault),
      expression: "config.order.forward.shippingMethodDefault"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order.forward, "shippingMethodDefault", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Não utilizar")]), _vm._v(" "), _vm._l((_vm.tinyShippingMethods), function(shippingMethod) {
    return _c('option', {
      key: shippingMethod.code,
      domProps: {
        "value": shippingMethod.code
      }
    }, [_vm._v(_vm._s(shippingMethod.label))])
  })], 2) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.config.order.forward.shippingMethodMap), function(shippingMethodMap) {
    return _c('form-group', {
      key: shippingMethodMap.hub,
      attrs: {
        "label": shippingMethodMap.hub
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shippingMethodMap.erp),
        expression: "shippingMethodMap.erp"
      }],
      staticClass: "form-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shippingMethodMap, "erp", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Não utilizar")]), _vm._v(" "), _vm._l((_vm.tinyShippingMethods), function(shippingMethod) {
      return _c('option', {
        key: shippingMethod.code,
        domProps: {
          "value": shippingMethod.code
        }
      }, [_vm._v(_vm._s(shippingMethod.label))])
    })], 2)])
  }), 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1e621fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Tiny.vue
// module id = 3459
// module chunks = 0